export const FirmwareUpdateConnectedStates = [
  'updatingFirmware',
  'updatingFirmwareProgramStarting',
  'updatingFirmwareProgramExecuting',
  'updatingFirmwareProgramStopping',
];
export const FirmwareUpdateStates = FirmwareUpdateConnectedStates.concat(['finalizingUpdates']);
export const NotInitializedStates = FirmwareUpdateStates.concat([
  'disconnected',
  'scanning',
  'connecting',
  'firmwareUpdateCheck',
  'validating',
  'notSupported',
  'querying',
]);

export const InitializedStates = ['ready', 'programStartingLocal', 'programExecutingLocal', 'programExecutingObserved', 'programStopping'];

export const allStates = NotInitializedStates.concat(InitializedStates);
